import { text_colorTextSecondary } from 'ext-ui/style/colors'
import { flyout_innerBlockVSpacing, spacing } from 'ext-ui/style/spacing'
import { fontRegular } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const noExpenseCategoriesMessage = css`
  ${fontRegular};
  color: ${text_colorTextSecondary};
`

export const formContainer = css`
  display: flex;
  flex-direction: column;
  gap: ${flyout_innerBlockVSpacing};
`

export const archivedDetailsContainer = css`
  display: flex;
  flex-direction: column;
  gap: ${flyout_innerBlockVSpacing};
  margin-top: ${spacing(8)};
`
